import { onlyDateFromServer } from '@common-fe/common-fe';
import { toString } from 'lodash';

import { IOcrAccountOrderDto, IOcrAccountOrderDtoAccountTypeEnum  } from '@/dtos';
import { OcrAccountOrderOption } from '@/modules/UseMyMoney/UseMyMoney.types';

export const formatOcrAccountOrder = (accountOrder: IOcrAccountOrderDto, index: number): OcrAccountOrderOption => ({
  index: toString(index),
  accountId: toString(accountOrder?.account_id),
  order: accountOrder?.order,
  planName: accountOrder?.plan_name,
  accountType: accountOrder?.account_type as unknown as IOcrAccountOrderDtoAccountTypeEnum ,
  availableBalance: accountOrder?.available_balance,
  services: accountOrder?.services
    ?.filter((service) => !!service?.name)
    ?.map((service) => ({
      id: toString(service?.id),
      name: service?.name || '',
    })),
  coverageDateStart: accountOrder?.coverage_date_start
    ? onlyDateFromServer(`${accountOrder?.coverage_date_start}`)
    : undefined,
  coverageDateEnd: accountOrder?.coverage_date_end
    ? onlyDateFromServer(`${accountOrder?.coverage_date_end}`)
    : undefined,
  submitClaimsDateEnd: accountOrder?.submit_claims_date_end
    ? onlyDateFromServer(`${accountOrder?.submit_claims_date_end}`)
    : undefined,
});
